// extracted by mini-css-extract-plugin
export default {"MuiInputBase-root":"TextField_MuiInputBase-root__MZ+sw","MuiInputBase-input":"TextField_MuiInputBase-input__KTGvc","MuiInputBase-sizeSmall":"TextField_MuiInputBase-sizeSmall__v4VUj"};